export default {
  selectedLocation: state => state.selectedLocation,
  createLocationDialog: state => state.createLocationDialog,
  locationEditDialog: state => state.locationEditDialog,
  images: state => state.images,
  enableZonesReload: state => state.enableZonesReload,
  selectedLocationCoordinates: state => {
    if (state.selectedLocation && state.selectedLocation.address){
      return {
        lat: state.selectedLocation.address.latitude,
        lng: state.selectedLocation.address.longitude,
      }
    }
    return {
      lat: 48.117266,
      lng: -1.6777926,
    }
  },
}
